import { DashboardOutlined, CreditCardOutlined, ApiOutlined, SettingOutlined } from '@ant-design/icons';

const icons = {
  DashboardOutlined,
  CreditCardOutlined,
  ApiOutlined,
  SettingOutlined
};

const gpo = {
  id: 'group-gpo',
  title: 'Gestão',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Painel',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'payments',
      title: 'Pagamentos',
      type: 'item',
      url: '/payments',
      icon: icons.CreditCardOutlined,
      breadcrumbs: false
    },
    {
      id: 'webhooks',
      title: 'Webhooks',
      type: 'item',
      url: '/webhooks',
      icon: icons.ApiOutlined,
      breadcrumbs: false
    },
    {
      id: 'settings',
      title: 'Definições',
      type: 'item',
      url: '/settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false
    }
  ]
};

export default gpo;
